import axaFavicon from "../assets/img/axa_favicon.ico";
import holFavicon from "../assets/img/hol_favicon.ico";

export default {
  Manifest: {
    Any: {
      name: "Member online",
      short_name: "Member online",
      icons: [
        {
          sizes: "32x32 16x16",
          type: "image/x-icon"
        }
      ],
      display: "browser",
      theme_color: "#00008F",
      background_color: "#ffffff"
    },
    HOL: {
      name: "Customer online",
      short_name: "Customer online",
      icons: [
        {
          sizes: "16x16",
          type: "image/x-icon"
        }
      ],
      display: "browser",
      theme_color: "#fbaf29",
      background_color: "#ffffff"
    }
  },
  Favicon: {
    Any: axaFavicon,
    HOL: holFavicon
  }
};
